var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticStyle:{"padding":"10px"},attrs:{"disabled":""},on:{"click":_vm.ComPortTesting}},[_vm._v(" COM測試 ")]),_c('el-input',{staticStyle:{"padding":"10px"},attrs:{"type":"textarea","rows":10,"placeholder":""},model:{value:(_vm.log),callback:function ($$v) {_vm.log=$$v},expression:"log"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }